/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';
import { StyleSheet, TouchableHighlight, View } from 'react-native';
import DyteClient from '@dytesdk/web-core';
import { SvgXml } from 'react-native-svg';
import { defaultIconPack, IconPack } from '../lib/icons';
import { DyteI18n, useLanguage } from '../lib/lang';
import DyteText from './DyteText';
import { useDyteSelector } from '@dytesdk/react-native-core';
import { DyteUIContext } from '../lib/context-provider/ui-context';

export const canRequestToJoinStage = (meeting: DyteClient) => {
  return (
    meeting?.self?.permissions.stageEnabled &&
    meeting?.self?.permissions.stageAccess !== 'NOT_ALLOWED'
  );
};

export default function ({
  meeting,
  iconPack,
  size = 'sm',
  variant = 'button',
  t,
}: {
  meeting: DyteClient;
  iconPack?: IconPack;
  size?: 'lg' | 'md' | 'sm' | 'xl';
  variant?: 'button' | 'horizontal';
  t?: DyteI18n;
}) {
  const defaultLang = useLanguage();
  t = t ?? defaultLang;
  iconPack = iconPack ?? defaultIconPack;
  const [onStage, setOnStage] = useState(false);
  const { storeStates, setStates } = useContext(DyteUIContext);
  const { colors } = storeStates.designSystem;
  const selfStageStatus = useDyteSelector((m) => m.stage.status);
  const toggleStage = () => {
    const self = meeting.self;
    if (self == null) {
      return;
    }
    if (selfStageStatus === 'REQUESTED_TO_JOIN_STAGE') {
      meeting.stage.cancelRequestAccess();
      return;
    }
    setStates({ ...storeStates, activeStageConfirmation: true });
  };
  useEffect(() => {
    const updateCanProduceSS = () => {
      const { self, meta, stage } = meeting;
      let _canProduceSS = self.permissions.canProduceScreenshare === 'ALLOWED';
      const isWebinar = meta.viewType === 'WEBINAR';
      if (!_canProduceSS && isWebinar) {
        const canRequestVideo =
          self.permissions.canProduceScreenshare === 'CAN_REQUEST';
        // If the has approved request to present
        if (
          canRequestVideo &&
          (stage.status === 'ON_STAGE' ||
            stage.status === 'ACCEPTED_TO_JOIN_STAGE')
        ) {
          _canProduceSS = true;
        }
      }
      setOnStage(_canProduceSS);
    };

    updateCanProduceSS();
    meeting.stage.addListener('stageStatusUpdate', updateCanProduceSS);

    return () => {
      meeting.stage.removeListener('stageStatusUpdate', updateCanProduceSS);
    };
  }, [meeting]);

  const styles = StyleSheet.create({
    buttonContainer: {
      alignItems: 'center',
      justifyContent: 'center',
    },
    iconStyle: {
      height: 56,
      width: 56,
      marginTop: 10,
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
    },
    button: {
      justifyContent: 'center',
      alignItems: 'center',
    },
    icon: {
      flex: 1,
      flexDirection: 'column',
      padding: 4,
      marginBottom: 10,
      alignItems: 'center',
      justifyContent: 'center',
      // flexWrap: 'wrap',
    },
  });
  if (meeting.meta.viewType !== 'WEBINAR') return null;
  if (!canRequestToJoinStage(meeting)) return null;
  return (
    <View style={styles.buttonContainer}>
      <TouchableHighlight
        underlayColor={colors.background[800]}
        onPress={toggleStage}
        style={styles.iconStyle}
      >
        <View style={styles.icon}>
          {selfStageStatus === 'OFF_STAGE' ? (
            <SvgXml
              xml={iconPack.join_stage.replace('currentColor', colors.text)}
              width={25}
              height={25}
            />
          ) : (
            <SvgXml
              xml={iconPack.leave_stage.replace('currentColor', colors.danger)}
              width={25}
              height={25}
            />
          )}
          {/* eslint-disable-next-line react-native/no-inline-styles*/}
          <DyteText style={{ fontSize: 11, marginTop: 4 }}>
            {selfStageStatus === 'ON_STAGE' && 'Leave'}
            {selfStageStatus === 'OFF_STAGE' && 'Join'}
            {selfStageStatus === 'REQUESTED_TO_JOIN_STAGE' && 'Requested'}
            {selfStageStatus === 'ACCEPTED_TO_JOIN_STAGE' && 'Accepted'}
          </DyteText>
        </View>
      </TouchableHighlight>
    </View>
  );
}
